import React from 'react';
import './About.css';

const About = () => {
  const values = [
    {
      icon: '🎯',
      title: 'Mission-Driven',
      description: 'We believe great startups begin with the right team. Our mission is to connect ambitious founders with their ideal partners.'
    },
    {
      icon: '🤝',
      title: 'Community First',
      description: 'We foster a supportive community where entrepreneurs can learn, grow, and succeed together.'
    },
    {
      icon: '🔒',
      title: 'Trust & Transparency',
      description: 'We prioritize user privacy and maintain transparent practices in all our operations.'
    },
    {
      icon: '🚀',
      title: 'Innovation',
      description: 'We continuously innovate to provide the best tools and features for co-founder matching.'
    },
    {
      icon: '🌍',
      title: 'Global Impact',
      description: 'We connect founders worldwide, breaking geographical barriers to entrepreneurship.'
    },
    {
      icon: '💡',
      title: 'Excellence',
      description: 'We maintain high standards in everything we do, from product quality to customer service.'
    }
  ];

  const milestones = [
    {
      year: '2026',
      title: 'Development Started',
      description: 'CofounderHubs development begins in February 2026. Building the platform to connect ambitious founders with their ideal co-founders.'
    },
    {
      year: '2026',
      title: 'Beta Phase',
      description: 'Platform enters beta testing with early adopters and selected founders for feedback and refinement.'
    },
    {
      year: '2026',
      title: 'Official Launch',
      description: 'CofounderHubs officially launches to the public with core features and community feed.'
    },
    {
      year: '2026',
      title: 'Feature Expansion',
      description: 'Launch of advanced matching algorithms, AI-powered recommendations, and enhanced user experience.'
    },
    {
      year: '2027',
      title: 'Global Expansion',
      description: 'Expanding to new markets and introducing multi-language support for international founders.'
    },
    {
      year: '2027',
      title: 'Investment Integration',
      description: 'Integration of investment capabilities, connecting startups with potential investors and venture capital.'
    }
  ];

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-content">
          <h1 className="about-hero-title">About CofounderHubs</h1>
          <p className="about-hero-subtitle">
            Connecting ambitious founders with their ideal co-founders to build the next generation of startups.
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="about-section">
        <div className="about-container">
          <div className="about-content">
            <h2>Our Mission</h2>
            <p>
              Finding the Right Co-Founder is a Challenging Journey. Building a successful startup begins with assembling the right team, and finding the ideal co-founder is no easy task. It requires time, effort, and the right connections. While there are numerous platforms available globally to help match startup co-founders, each comes with its own set of advantages and challenges.
            </p>
            <p>
              After carefully studying and evaluating many co-founder matchmaking platforms, we have identified Startup School as the leading, most reliable platform for finding authentic co-founders. It stands out for its credibility and track record in fostering genuine, successful partnerships.
            </p>
            <p>
              Our vision is to automate the process of connecting and analyzing potential co-founders. By leveraging data-driven insights, we aim to simplify and accelerate the matchmaking process, providing a seamless experience for all users.
            </p>
            <p>
              Looking ahead, we plan to integrate investment capabilities into our platform, allowing startups to not only find co-founders but also connect with potential investors who share their vision and goals.
            </p>
            <p>
              While our platform is designed for startup founders, we are also dedicated to helping individuals who aspire to become founding engineers, team members, or staff at innovative companies.
            </p>
            <p>
              Our ultimate goal is to create a comprehensive service platform that empowers entrepreneurs to build exceptional companies from the ground up — bringing together the right talent, the right funding, and the right opportunities for success.
            </p>
          </div>
          <div className="about-image">
            <img src="/img/business-handshake.jpg" alt="Business partnership" />
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="about-section about-values-section">
        <div className="about-container">
          <h2 className="section-title">Our Values</h2>
          <div className="values-grid">
            {values.map(value => (
              <div key={value.title} className="value-card">
                <div className="value-icon">{value.icon}</div>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Milestones Section */}
      <section className="about-section about-milestones-section">
        <div className="about-container">
          <h2 className="section-title">Our Journey</h2>
          <div className="milestones-timeline">
            {milestones.map((milestone, index) => (
              <div key={index} className="milestone-item">
                <div className="milestone-year">{milestone.year}</div>
                <div className="milestone-content">
                  <h3>{milestone.title}</h3>
                  <p>{milestone.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-section about-cta-section">
        <div className="about-container about-cta-content">
          <h2>Ready to Find Your Co-founder?</h2>
          <p>Join thousands of founders building the future together.</p>
          <div className="cta-buttons">
            <a href="/signup" className="cta-btn cta-btn-primary">Get Started</a>
            <a href="/help" className="cta-btn cta-btn-secondary">Learn More</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
